module.exports = __webpack_public_path__ + "static/media/about1.5ad0cc89.jpg";